import { useId, useState } from 'react';
import { useT } from '@/i18n/runtime';
import { Button } from './Button';

/**
 * Report-a-concern (FSD §2.6 J0): an inline disclosure, never a modal, that tells the
 * representative the ONE honest thing — do not continue; reach the client through a channel you
 * already trust, not through this page. §2 has no capture-plane endpoint for a concern record
 * (parked for the be lane); the "stop" action ends the flow locally without recording anything.
 */
export function ConcernPanel({ tenantName, onStop }: { tenantName: string; onStop?: () => void }): JSX.Element {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <div className="sv-concern">
      <button type="button" className="sv-concern-trigger" aria-expanded={open} aria-controls={id} onClick={() => setOpen((v) => !v)}>
        {t('sv.door.concern.trigger')}
      </button>
      {open ? (
        <div id={id} className="sv-concern-panel" role="group">
          <div className="h-title sm">{t('sv.door.concern.title')}</div>
          <p className="sub-sm">{t('sv.door.concern.body', { tenantName })}</p>
          <p className="sub-sm">{t('sv.door.concern.body2')}</p>
          {onStop ? (
            <Button variant="ghost" onClick={onStop}>
              {t('sv.door.concern.stop')}
            </Button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
